export default __webpack_public_path__ + "static/result-11f4fe24c20ceaa62997837e8d8915e8.gif";